import { Flex, Select, SelectProps, Tag } from "antd";
import { useTranslation } from "react-i18next";

import SText from "@/styles/SText";
import { numFormmater } from "@/pages/Requirement/util";
import { PackSourceItem } from "@/types/packing";
import { useMemo } from "react";

interface SelectSourceItemProps extends SelectProps {
  list: Array<PackSourceItem>;
  onChangeItem?: (info: PackSourceItem) => void;
}

const SelectSourceItem = ({
  list,
  onChangeItem,
  onChange,
  ...props
}: SelectSourceItemProps) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return list.map(o => ({ ...o, disabled: (o.remainingCount ?? 0) <= 0 }))
  }, [list]);

  return (
    <Select
      onChange={(val, info) => {
        onChange?.(val, info);
        onChangeItem?.(info as PackSourceItem)
      }}
      optionRender={(info) => (
        <Flex gap={8}>
          <Tag color="geekblue">{(info.data as PackSourceItem).product.code}</Tag>
          <SText text={(info.data as PackSourceItem).product.name} />
          <SText style={{ textAlign: "right" }} text={t('warehouse.remainPack') + ": " + numFormmater((info.data as PackSourceItem).remainingCount ?? 0)} />
        </Flex>
      )}
      labelRender={(info) => {
        const data = options.find(d => d.productId === info.value);
        return data && (
          <Flex gap={8} justify="space-between">
            <Tag color="geekblue">{data.product.code}</Tag>
            <SText text={data.product.name} />
            <SText style={{ textAlign: "right" }} text={t('warehouse.remainPack') + ": " + numFormmater(data.remainingCount ?? 0)} />
          </Flex>
        )
      }}
      style={{ width: "100%" }}
      options={options}
      fieldNames={{ value: 'productId' }}
      showSearch
      filterOption={(input, option) =>
        (option?.product?.code ?? "").toLowerCase().includes(input.toLowerCase())
      }
      {...props}
    />
  );
};

export default SelectSourceItem;
